import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'

const getWeather = (temp, weather) => {
    let label = "";
    let title = "";

    if (weather.includes("Rain")) {
        label = "Rainy";
        title = "Rainy now";
    } else if (weather.includes("Snow")) {
        label = "Snowy";
        title = "Cold now";
    } else if (temp >= 18 && temp <= 26) {
        label = "Perfect";
        title = "Perfect now"
    } else if (temp >= 27 && temp <= 32) {
        label = "Warm";
        title = "Great now"
    } else if (temp > 32) {
        label = "Hot";
        title = "Too hot";
    } else if (temp >= 10 && temp <= 17) {
        label = "Cool";
        title = "Nice now";
    } else {
        label = "Cold";
        title = "Cold now";
    }

    return { label, title };
};

const CACHE_TTL = 60 * 60 * 1000;

export const InfoWeather = ({ country_capital }) => {
    const [weather, setWeather] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false); 

    useEffect(() => {
        if (!country_capital) return;

        const fetchWeather = async () => {
            setLoading(true);
            setError(false);

            const cacheKey = `weather_${country_capital}`;
            const cached = localStorage.getItem(cacheKey);

            if (cached) {
                const parsed = JSON.parse(cached);

                if (Date.now() - parsed.timestamp < CACHE_TTL) {
                    setWeather(parsed.data);
                    setLoading(false);
                    return;
                }
            }

            try {
                const API_KEY = process.env.REACT_APP_WEATHER_API_KEY;
                const resp = await fetch(
                    `https://api.openweathermap.org/data/2.5/weather?q=${country_capital}&units=metric&appid=${API_KEY}`
                );

                if (!resp.ok) throw new Error('Weather API error');

                const data = await resp.json();

                const temp = Math.round(data.main.temp);
                const main = data.weather[0].main;
                const iconCode = data.weather[0].icon;

                const ux = getWeather(temp, main);

                const weatherData = {
                    temp,
                    main,
                    iconCode,
                    ...ux
                };

                setWeather(weatherData);

                localStorage.setItem(
                    cacheKey,
                    JSON.stringify({
                        data: weatherData,
                        timestamp: Date.now()
                    })
                );

            } catch {
                setError(true); 
                setWeather(null);
            } finally {
                setLoading(false);
            }
        };

        fetchWeather();
    }, [country_capital]);

    if (loading) { 
        return (
            <div className={styles.loaderWrapper}>
                <div className={styles.loading}> Loading weather... </div>
            </div>
        )    
    } 
    if (error) {
        return (
            <div className={styles.loaderWrapper}> 
                <div className={styles.err}> 🌈 Weather info missing </div> 
            </div>
            ); 
    } 
    if (!weather) { 
        return null; 
    }

    return (
        <div className={styles.weather_main}>
            <div className={styles.weather_temp}>
                <span>{weather.temp}°</span>
                <img
                        className={styles.weather_img}
                        src={`https://openweathermap.org/img/wn/${weather.iconCode}@2x.png`}
                        alt=""
                />
            </div>        
            <div className={styles.weather_title}>{weather.title}</div>
        </div>
    );
};
// https://api.openweathermap.org/data/2.5/weather?q=${moscow}&units=metric&appid=${45e43004211e70667e048d54fe6aa7ad}
// https://api.openweathermap.org/data/2.5/weather?lat=44.34&lon=10.99&appid={45e43004211e70667e048d54fe6aa7ad}
// https://api.openweathermap.org/data/2.5/weather?q=${moscow}&appid=${45e43004211e70667e048d54fe6aa7ad}